import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExtraFilteringOptions, LoadOptions} from '../../../shared/models/shared.model';
import {Subject} from 'rxjs';
import {GridSetting, GridSettings, GridState, User} from '../../../shared';
import {UserApi} from '../../../api';
import {FilterBuilderService} from '../../../service/filter-builder.service';
import {LoaderService} from '../../../core/loader/loader.service';
import {QuarterMasterService} from '../../../api/quarter-master.service';
import {DxDataGridComponent} from 'devextreme-angular';
import {take, takeUntil} from 'rxjs/operators';
import CustomStore from 'devextreme/data/custom_store';
import {MappingAction} from '../../../shared/enum/mapping-mode.enum';
import {
  QuarterMasterGridEditingOption,
  QuarterMasterGridMappingOption,
  QuarterMasterGridModel
} from '../../../shared/models/quarter-master.model';

@Component({
  selector: 'quarter-master-mapping',
  templateUrl: 'quarter-master-mapping.component.html'
})

export class QuarterMasterMappingComponent implements OnInit, OnDestroy {
  @ViewChild('quarterMasterMappingDataGrid') quarterMasterMappingDataGrid: DxDataGridComponent;

  public quarterMasterMappingDataSource = {};
  public quarterMasterMappingSelectedRowMap = [];

  public currentUser: User;
  public extraFilteringOptions: ExtraFilteringOptions[] = [
	{ column: 'Active', value: false },
  ];

  private _destroyed$ = new Subject();

  public isLoadQuarterMasterGridDataSource: boolean;

  public createdByHeaderDataSource: any;
  public modifiedByHeaderDataSource: any;
  public reviewedByHeaderDataSource: any;
  public reviewedOnHeaderDataSource: any;
  public createdOnHeaderDataSource: any;
  public modifiedOnHeaderDataSource: any;
  public yearHeaderDataSource: any;
  public quarterHeaderDataSource: any;
  public timePeriodKeyHeaderDataSource: any;


  private readonly masterGridName: string = 'quarterMasterDataGrid';
  private readonly pageName: string = 'quarterMasterMapping';
  private currentQuarterMasterDataGridState: GridState;
  private quarterMasterDataGridSettings: GridSettings;
  private isQuarterMasterDataGridSettingLoading = true;
  private quarterMasterDataGridSetting: GridSetting = new GridSetting();
  private mappingDataGridCurrentPage: number;
  private isQuarterMasterMappingDataLoading: boolean;

  constructor(
		private quarterMasterService: QuarterMasterService,
		private userService: UserApi,
		private filterBuilder: FilterBuilderService,
		private loaderService: LoaderService,
  ) {}

  ngOnInit() {
	this.loaderService.show();
	this.currentUser = this.userService.logonUser;
	if (!this.currentUser) {
		return;
	}

	this.quarterMasterDataGridSettings = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};

	this.userService.getGridSettings(this.quarterMasterDataGridSettings)
		.pipe(take(1))
		.subscribe((settings) => {
		if (settings && settings.Settings) {
			if (typeof settings.Settings === 'string') {
			this.quarterMasterDataGridSetting = JSON.parse(settings.Settings);
			} else {
			this.quarterMasterDataGridSetting = settings.Settings;
			}
		} else {
			this.quarterMasterDataGridSettings.Settings = JSON.stringify({autosave: true});
			this.updateGridSettings(this.quarterMasterDataGridSettings);
		}
		this.loadQuarterMasterDataGridState();
		});

	this.headerFilterDataSets();
  }

  public loadMasterState = () => {
	return this.currentQuarterMasterDataGridState.State ? JSON.parse(this.currentQuarterMasterDataGridState.State) : null;
  }

  public saveMasterState = (state) => {
	if (this.quarterMasterDataGridSetting) {
		let gridSetting: GridSetting;
		if (typeof this.quarterMasterDataGridSetting === 'string') {
		gridSetting = JSON.parse(this.quarterMasterDataGridSetting);
		} else {
		gridSetting = this.quarterMasterDataGridSetting;
		}
		if (gridSetting.autosave) {
		this.currentQuarterMasterDataGridState.State = JSON.stringify(state);
		this.updateGridState(this.currentQuarterMasterDataGridState);
		}
	}
  }

  public selectionMappingDataChangedHandler() {
	if (this.quarterMasterMappingDataGrid.instance.getSelectedRowsData()[0]) {
		this.quarterMasterMappingSelectedRowMap = this.quarterMasterMappingDataGrid.instance.getSelectedRowsData()[0];
	}
  }

  public onReady(e) {
	const grid = e.component;
	const selection = grid.getSelectedRowKeys();
	if (selection.length === 0) {
		grid.selectRowsByIndexes([0]);
	}
  }

  public quarterMasterMappingDataGridContextMenu(e) {
	if (e.target === 'content') {
		// e.items can be undefined
		if (!e.items) { e.items = []; }

		// Add a custom menu item
		e.items.push(
		{
			text: 'Refresh',
			icon: 'refresh',
			onItemClick: () => {
			this.refreshQuarterMasterMappingDataGrid();
			}
		},
		{
			text: 'Grid Settings',
			items: [
			{
				text: this.quarterMasterDataGridSetting.autosave ? 'Disable autosave' : 'Enable autosave',
				onItemClick: () => {
				this.quarterMasterDataGridSetting.autosave = !this.quarterMasterDataGridSetting.autosave;
				this.quarterMasterDataGridSettings.Settings = JSON.stringify(this.quarterMasterDataGridSetting);
				this.updateGridSettings(this.quarterMasterDataGridSettings);
				}
			}
			]
		}
		);
	}
  }

  private loadQuarterMasterDataGridState() {
	const quarterMasterDataGridState: GridState = {
		PageName: this.pageName,
		GridName: this.masterGridName,
		OwnedByUserId: this.currentUser.UserId
	};
	this.userService.getGridState(quarterMasterDataGridState)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((state) => {
		if (state) {
			this.currentQuarterMasterDataGridState = state;
		} else {
			this.currentQuarterMasterDataGridState = {
			PageName: this.pageName,
			GridName: this.masterGridName,
			OwnedByUserId: this.currentUser.UserId,
			State: null
			};
		}
		this.loadQuarterMasterMappingDataSource();
		});
  }

  private loadQuarterMasterMappingDataSource() {
	this.isQuarterMasterDataGridSettingLoading = false;
	this.quarterMasterMappingDataSource = new CustomStore({
		key: 'QuarterId',
		load: (loadOptions: any) => {
		this.isQuarterMasterMappingDataLoading = true;
		this.loaderService.show();
		const filter = this.formatFilterOperators(loadOptions.filter);
		const finalOptions: LoadOptions = loadOptions;
		finalOptions.filter = filter;
		finalOptions.extraParams = this.extraFilteringOptions;

		return this.quarterMasterService.getQuarterMasterGrid(finalOptions)
			.toPromise()
			.then((data: any) => {
			this.isQuarterMasterMappingDataLoading = false;
			this.loaderHandler();
			return {
				data: data.data,
				totalCount: data.totalCount,
				summary: data.summary,
				groupCount: data.groupCount
			};
			})
			.catch(error => {
			this.isQuarterMasterMappingDataLoading = false;
			this.loaderHandler();
			throw new Error('Data Loading Error');
			});
		},
		update: (key, value) => {
		return value;
		}
	});
	this.isLoadQuarterMasterGridDataSource = true;
  }

  private loaderHandler() {
	if (!this.isQuarterMasterMappingDataLoading && !this.isQuarterMasterDataGridSettingLoading) {
		this.loaderService.hide();
	}
  }

  private formatFilterOperators(rawFilter: any[]) {
	if (!rawFilter) {
		return null;
	}
	const filterData = this.filterBuilder.handleNotFilterFormatting(rawFilter);
	return this.filterBuilder.filterFormatting(filterData);
  }

  private updateGridSettings(gridSettings: GridSettings) {
	gridSettings.SavedOn = new Date();
	this.userService.setGridSettings(gridSettings).pipe(take(1)).subscribe();
  }

  private updateGridState(gridState: GridState) {
	gridState.SavedOn = new Date();
	this.userService.setGridState(gridState).pipe(take(1)).subscribe();
  }

  extraFilteringOptionsChange(columnName, event) {
	if (event) {
		const option = this.extraFilteringOptions.find(item => item.column === columnName);
		option.value =  event.value;
		this.quarterMasterMappingDataGrid.instance.deselectAll();
		this.refreshQuarterMasterMappingDataGrid();
	}
  }

  refreshQuarterMasterMappingDataGrid() {
	this.mappingDataGridCurrentPage = this.quarterMasterMappingDataGrid.instance.pageIndex();
	this.quarterMasterMappingDataGrid.instance.refresh();
  }

  public customizeQuarterMasterId(cellInfo) {
	const idStr = 'QrMp_000000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  ngOnDestroy() {
	this.loaderService.hide();
	this._destroyed$.next(null);
	this._destroyed$.complete();
  }

  private headerFilterDataSets() {
	this.yearHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Year';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.quarterHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'Quarter';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.timePeriodKeyHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'TimePeriodKey';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.createdByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.modifiedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.reviewedByHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedByUserFullNameSortableOrPrincipalName';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.createdOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'CreatedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.modifiedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ModifiedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});

	this.reviewedOnHeaderDataSource = new CustomStore({
		load: (loadOptions: any) => {
		loadOptions.column = 'ReviewedOn';
		loadOptions.valueColumn = '';

		return this.getHeaderFiltersCountryMapping(loadOptions);
		}
	});
  }

  deactivate(quarterId: any) {
	const mappingData: QuarterMasterGridMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.QuarterId = quarterId;
	mappingData.ActionType = MappingAction.Deactivate;
	this.loaderService.show();
	this.quarterMasterService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshQuarterMasterMappingDataGrid();
		});
  }

  reactivate(quarterId: any) {
	const mappingData: QuarterMasterGridMappingOption = {};
	mappingData.ModifiedByUserId = this.currentUser.UserId;
	mappingData.QuarterId = quarterId;
	mappingData.ActionType = MappingAction.Reactivate;
	this.loaderService.show();
	this.quarterMasterService.mappingAction(mappingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		this.refreshQuarterMasterMappingDataGrid();
		});
  }

  private getHeaderFiltersCountryMapping(loadingOption) {
	return this.quarterMasterService.getHeaderFiltersQuarterMasterGrid(loadingOption)
		.toPromise()
		.catch(error => { throw new Error('Data Loading Error'); });
  }

  public addQuarterMaster() {
	const createdByUserId = this.currentUser.UserId;
	this.quarterMasterService.addNewQuarterMaster(createdByUserId)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		if (res) {
			this.refreshQuarterMasterMappingDataGrid();
		}
		});
  }

  public saveEdit(event) {
	const data: QuarterMasterGridModel = event.oldData;
	const newDataKeys = Object.keys(event.newData);
	newDataKeys.forEach(item => {
		data[item] = event.newData[item];
	});

	const editingData: QuarterMasterGridEditingOption = {
		ModifiedByUserId: this.currentUser.UserId,
		QuarterId: data.QuarterId,
		IsCovidPassThrough: data.IsCovidPassThrough,
		IsReleased: data.IsReleased,
		IsMapping: data.IsMapping
	};
	this.quarterMasterService.editingAction(editingData)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res) => {
		});
  }

  public rowUpdated() {
	this.refreshQuarterMasterMappingDataGrid();
  }
}
